import logo from "../../../../assets/img/organicWhiteLogo.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
import useWindowWidth from "../../../../Hooks/useWindow";
import NavMenu from "../../../AssociatePanel/componets/HeaderProperty/NavMenu";
const BrandLogo = () => {
  const dispatch = useDispatch();

  const width = useWindowWidth();

  return (
    <div className="navbar-logo">
      {/* <button
        className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTopCollapse"
        aria-controls="navbarTopCollapse"
        aria-expanded="true"
        aria-label="Toggle Navigation"
        onClick={handleToggle}
      >
        <span className="navbar-toggle-icon text-light">
          <span className="toggle-line text-light" />
        </span>
      </button> */}

      <nav>
        {width <= 1230 && (
          <button
            onClick={() => dispatch(uiAction.setSideBarToggle())}
            className="btn btn-link p-0 me-3 text-white"
          >
            {/* Hamburger Icon */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        )}

        {/* <NavMenu /> */}
      </nav>

      <Link className="navbar-brand" to="/dashboard">
        <img
          style={
            width > 990
              ? { width: "100px", height: "55px", margin: "10px" }
              : { width: "100px", height: "50px", margin: "10px" }
          }
          src={logo}
          alt="Logo"
        />
      </Link>
    </div>
  );
};

export default BrandLogo;
